interface CreateAssetFilenameProps {
  name: string;
  backupFileName: "brandlogo" | "element" | "buttonlogo" | "asset" | "font";
}

export function create_asset_filename({ name, backupFileName }: CreateAssetFilenameProps): string {
  /**
   * check for non-roman characters using regex and set backup file name if required (AF 09-10-23)
   * https://stackoverflow.com/questions/24107993/how-to-detect-non-roman-characters-in-js
   */
  name = /[^\u0000-\u024F\u1E00-\u1EFF\u2C60-\u2C7F\uA720-\uA7FF]/g.test(name) ? backupFileName : name;
  /**
   * Renaming files to remove all special characters and spaces, then join together. image-thing-1231231.jpg ->  imagething1231231.jpg
   * Also renaming files to 30 characters for legibility
   */
  let fileName = name
    .split(".")[0]
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase()
    .substring(0, 30);
  return fileName;
}
